
import { Link } from "react-router-dom";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  console.log("Footer: Initializing component");
  
  return (
    <footer className="bg-gray-50 border-t mt-auto">
      <div className="container mx-auto px-4 py-8">
        <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <div className="flex flex-col md:flex-row items-center space-y-2 md:space-y-0 md:space-x-6">
            <Link 
              to="/cgv" 
              className="text-sm text-gray-600 hover:text-primary transition-colors"
              onClick={() => console.log("Footer: Navigating to CGV")}
            >
              Conditions générales de ventes
            </Link>
            <Link 
              to="/confidentialite" 
              className="text-sm text-gray-600 hover:text-primary transition-colors"
              onClick={() => console.log("Footer: Navigating to Confidentialité")}
            >
              Politique de confidentialité
            </Link>
          </div>
          <p className="text-sm text-gray-500">
            © {currentYear} Agroref. Tous droits réservés.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
